module.exports = __webpack_public_path__ + "img/monk.9ae83cbd.jpg";